import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';
import {ApiService} from './api.service';
import {Observable} from 'rxjs';
import 'rxjs/add/operator/map'

@Injectable()
export class IssuecodesService {

    constructor(
        private apiService: ApiService) {
    }

    getIssuecodes() {
        return this.apiService.http_get('/issuecodes/list');
    }
    getLegalIssues(data) {
        return this.apiService.http_post('/issuecodes/issuelist', data);
    }
    addIssuecodes(issuecodes) {
        return this.apiService.http_post('/issuecodes/add', issuecodes);
    }
    addImportedIssuecodes(issuecodes) {
        return this.apiService.http_post('/issuecodes/addImported', issuecodes);
    }
    updateIssuecodes(issuecodes) {
        return this.apiService.http_post('/issuecodes/update', issuecodes);
    }
   
    deleteIssuecode(issuecode) {
        return this.apiService.http_post('/issuecodes/delete', issuecode);
    }
    
    importIssueCode(fileToUpload: File){

        let file: File = fileToUpload['document'][0]
               let formData:FormData = new FormData();
        formData.append('file', file, file.name);
        formData.append('filename', file.name);
        return this.apiService.http_post('/issuecodes/importIssueCode',formData);
    }
    
    importLegalIssues(data) {
        return this.apiService.http_post('/issuecodes/importViaApi', data);
    }
   
}


// WEBPACK FOOTER //
// /var/www/html/LASO/laso-client/src/app/_services/issuecodes.service.ts